// extracted by css-extract-rspack-plugin
export default {"wrapper":"_d683cb3","img":"_6717ae23","imgWrapper":"_b6762a10","overlay":"_923c175a"};